export enum CommandState {
  New,
  Failed,
  Success,
  Finished,
  Pending,
  Delayed,
}

export function getCommandStateValues() {
  return [
    CommandState.Pending,
    CommandState.New,
    CommandState.Failed,
    CommandState.Finished,
    CommandState.Delayed,
  ];
}
